import { Key, Entity } from '@briebug/ngrx-auto-entity';

@Entity({ modelName: 'MaterialVendor' })
export class MaterialVendor {
  @Key id?: number;
  vendor: string;
  vendorName?: string;
  categories: number[];
}
